import { languages } from '../../../../../shared/app/constants/languages';
import { timerHelperModule } from '../../../../../shared/app/helpers/timer-helper';
import { safeUrlFilterModule } from '../../../../../shared/app/filters/safe-url-filter';
import { scoreLabelComponentModule } from '../../../../../shared/app/components/scores/score-label';
import { appAlertComponentModule } from '../../../../../shared/app/components/app-alert/app-alert';
import { dialogComponentModule } from '../../../../../shared/app/components/dialog/dialog';
import { assessmentSubmittingDialogComponentModule } from '../../../components/assessment-submitting-dialog/assessment-submitting-dialog';
// import { surveyDialogComponentModule } from '../../../components/survey-dialog/survey-dialog';
import { markdownEditorComponentModule } from '../../../../../shared/app/components/markdown-editor/markdown-editor';
import { codeHighlightComponentModule } from '../../../../../shared/app/components/code-highlight/code-highlight';
import { quizChallengeQuestionsComponentModule } from '../../../../../shared/app/components/quiz-challenge-questions/quiz-challenge-questions';
import reviewTemplate from './review.tpl.html';
import './review.less';
import { uiRouterStateModule } from '../../../../../shared/app/vendor/ui-router-module';
import { fileListViewerComponentModule } from '../../../../../shared/app/components/file-list-viewer/file-list-viewer';
import { stickyHeaderComponentModule } from '../../../../../shared/app/components/sticky-header/sticky-header';

export const reviewRouteModule = angular
  .module('Q.routes.assessments.review', [
    uiRouterStateModule,
    timerHelperModule,
    safeUrlFilterModule,
    scoreLabelComponentModule,
    appAlertComponentModule,
    dialogComponentModule,
    assessmentSubmittingDialogComponentModule,
    // surveyDialogComponentModule,
    markdownEditorComponentModule,
    codeHighlightComponentModule,
    quizChallengeQuestionsComponentModule,
    fileListViewerComponentModule,
    stickyHeaderComponentModule,
  ])
  .config(function ($stateProvider) {
    let candidateRemarks = '';

    $stateProvider.state('assessments.review', {
      url: '/review',
      template: reviewTemplate,
      data: {
        permissions: {
          loggedIn: true,
          redirectTo: 'assessments.welcome',
        },
        bodyClass: 'assessments review',
        label: 'Assessment Review',
      },
      resolve: {
        assessmentResult: /* @ngInject */ function (process) {
          return process.whenAssessmentResultReady();
        },
        initialLoad: /* @ngInject */ function ($state) {
          return !$state.current || !$state.current.name;
        },
      },
      controllerAs: 'review',
      controller: /* @ngInject */ function ReviewCtrl(
        $scope,
        process,
        assessmentResult,
        initialLoad,
        assessmentResultsService,
        appAlert,
        accountService,
        dialogService,
        $window,
        $log,
        assessmentSubmittingDialog,
        Solution,
        $state,
        photoManager,
      ) {
        if (process.invitationIssue) {
          // if there is an issue go to the welcome screen where we can tell them about it
          return $state.go('assessments.welcome');
        }

        const isOpen = assessmentResult && !assessmentResult.isClosed();
        const hasSolutions =
          assessmentResult &&
          assessmentResult.solutions &&
          assessmentResult.solutions.length;
        if (
          !assessmentResult ||
          (isOpen && process.embedOptions.hideReview) ||
          (isOpen && initialLoad && !hasSolutions)
        ) {
          $state.go('assessments.welcome');
          return;
        }

        const ctrl = this;
        ctrl.process = process;
        if (process.liveInterview.setActiveChallengeId) {
          process.liveInterview.setActiveChallengeId(null);
        }
        if (process.timer && assessmentResult.isStarted()) {
          process.timer.start(assessmentResult);
        }
        ctrl.assessmentResult = assessmentResult;

        // restore unsaved notes
        if (candidateRemarks) {
          assessmentResult.candidateRemarks = candidateRemarks;
        }

        ctrl.incompleteStage =
          !process.assessmentResult.isClosed() &&
          process.stages.challenges.find((c) => {
            return (
              c.solution &&
              c.solution.isAdvancedCode() &&
              c.solution.hasFailedSubmissionAttempts() &&
              c.solution.remainingAttempts()
            );
          });
        ctrl.hasUnusedAttempts = !!ctrl.incompleteStage;

        ctrl.isSafeToSubmit = () => {
          return process.isSafeToSubmit() && !ctrl.hasUnusedAttempts;
        };

        ctrl.canReviewSolutions = () => {
          return (
            assessmentResult.isStarted() ||
            assessmentResult.assessment.showSolutionsToCandidates
          );
        };

        // don't show the attempted data if there's no submitted data
        function notSubmitted(solution) {
          return solution && solution.isCode() && !solution.attempted();
        }

        // Show a different score & summary if the timer ran out
        function waitingOnScore(solution) {
          return assessmentResult.timerRanOut() && notSubmitted(solution);
        }

        ctrl.timerRanOut = () => {
          // only treat this as a timer ran out scenario if the timer ran out, this is not a demo or
          // practice assessment, and at least one started code challenge has a 0 score
          return (
            assessmentResult.timerRanOut() &&
            !process.isSample() &&
            assessmentResult.validSolutions().some(waitingOnScore)
          );
        };

        function updateCommentStatus() {
          ctrl.remarksSubmitted =
            assessmentResult.isSubmitted() &&
            !!assessmentResult.candidateRemarks;
          if (assessmentResult.isSubmitted()) {
            candidateRemarks = '';
          }
          ctrl.modifiedComments = false;
        }

        updateCommentStatus();

        ctrl.isSingleChallengeAssessment = process.challengeCount < 2;
        ctrl.canEdit = process.canEdit;
        ctrl.showActions =
          process.isTeamMember() ||
          (!process.restricted && (process.canEdit || !process.isEmbedded));
        ctrl.hasPostAssessmentRedirect =
          assessmentResult.hasPostAssessmentRedirect();
        ctrl.topSubmit =
          !process.isSample() &&
          ctrl.canEdit &&
          process.isSafeToSubmit() &&
          process.isFullyComplete();

        let user = accountService.get().user;
        ctrl.landingParams = ['email', 'firstName', 'lastName']
          .map((k) => k + '=' + encodeURIComponent(user[k]))
          .join('&');

        function _postSubmitHandler() {
          updateCommentStatus();
          ctrl.canEdit = process.canEdit;
          ctrl.didSubmit =
            assessmentResult.isSubmitted() || assessmentResult.isTerminated();
          ctrl.hasPostAssessmentRedirect =
            assessmentResult.hasPostAssessmentRedirect();
          ctrl.submitting = false;

          if (assessmentResult.isClosed()) {
            process.postSubmitted(assessmentResult);
            photoManager.stop();
          }
        }

        ctrl.submit = () => {
          ctrl.submitting = true;
          process
            .submitAssessment()
            // .then(({ redirected }) => {
            // 	if(!redirected) {
            // 		surveyDialog.openCandidateSurvey(assessmentResult, process);
            // 	}
            // })
            .finally(_postSubmitHandler);
        };

        ctrl.update = () => {
          ctrl.submitting = true;
          ctrl.savedComments = false;
          assessmentResultsService
            .update(assessmentResult)
            .then(updateCommentStatus)
            .catch(appAlert.modelError)
            .finally(() => {
              ctrl.submitting = false;
            });
        };

        ctrl.modifyComments = () => {
          ctrl.modifiedComments = true;
          candidateRemarks = assessmentResult.candidateRemarks;
        };

        ctrl.getStatus = (stage) => {
          return waitingOnScore(stage.solution) ? 'unknown' : stage.status;
        };
        ctrl.getSummary = (stage) => {
          if (waitingOnScore(stage.solution)) {
            return 'Timer Ran out';
          } else if (notSubmitted(stage.solution)) {
            return 'Submitting…';
          } else {
            return stage.label();
          }
        };
        ctrl.canReviewSolution = (stage) =>
          stage.solution && !waitingOnScore(stage.solution);

        ctrl.commentsLabel = () => {
          let label = 'Comments?';
          if (ctrl.process.restricted || ctrl.remarksSubmitted) {
            label = 'Your Comments';
          } else if (process.isPractice()) {
            label = 'Comments about the Practice Assessment?';
          } else if (process.isDemo()) {
            label = 'Comments about the Demo?';
          }
          return label;
        };

        // if we've already been submitted or is still submitting,
        // let the submitting dialog pop open
        if (assessmentResult.isClosed()) {
          ctrl.submit();
          if (
            assessmentResult.isSubmitted() ||
            assessmentResult.isTerminated()
          ) {
            _postSubmitHandler();
          }
        }

        ctrl.saveSolution = (solution) => {
          Solution.update(solution, {
            candidateNotes: solution.candidateNotes,
          }).catch(
            appAlert.modelError.with({ prefix: 'Unable to save your notes:' }),
          );
        };

        ctrl.frameworkLanguage = (solution) => {
          return languages.frameworkLanguage(
            solution.language,
            solution.testFramework,
          );
        };

        process.postUpdated(null, {
          id: 'review',
          title: 'Review',
          index: process.challengeCount + 1,
        });
      },
    });
  });
